<template>
    <el-dialog title="入库" :visible.sync="dialogVisible" width="42%" :close-on-click-modal="false" top="8vh" @close="close">
<!--        <upload-excel-component :on-success="handleSuccess" />-->
        <el-form label-width="100px">
            <el-form-item label="重量">
                <el-input size="mini" v-model="formData.purchaseWeight"></el-input>
            </el-form-item>
          <el-form-item label="长">
            <el-input size="mini" v-model="formData.length"></el-input>
          </el-form-item>
          <el-form-item label="宽">
            <el-input size="mini" v-model="formData.width"></el-input>
          </el-form-item>
          <el-form-item label="高">
            <el-input size="mini" v-model="formData.height"></el-input>
          </el-form-item>
            <el-form-item label="国内运单号">
                <el-input size="mini" v-model.trim="formData.internalConveyNumber" autofocus></el-input>
            </el-form-item>
        </el-form>
       <!-- <el-table :data="tableData" border style="margin-top: 20px;">
           <el-table-column label="国内运单号" align="center">
               <template slot-scope="scope">
                   <div :style="{color: isRepeat(scope.row) ? 'red' : ''}">{{ scope.row.internalConveyNumber }}</div>
                   &lt;!&ndash; <el-input
                       v-model="scope.row.internalConveyNumber"
                       placeholder="请输入内容"
                   ></el-input> &ndash;&gt;
               </template>
           </el-table-column>
           <el-table-column label="长" align="center" width="100">
               <template slot-scope="scope">
                   <el-input v-model="scope.row.length"></el-input>
               </template>
           </el-table-column>
           <el-table-column label="宽" align="center" width="100">
               <template slot-scope="scope">
                   <el-input v-model="scope.row.width"></el-input>
               </template>
           </el-table-column>
           <el-table-column label="高" align="center" width="100">
               <template slot-scope="scope">
                   <el-input v-model="scope.row.height"></el-input>
               </template>
           </el-table-column>
           <el-table-column label="重量" align="center" width="100">
               <template slot-scope="scope">
                   <el-input v-model="scope.row.purchaseWeight"></el-input>
               </template>
           </el-table-column>
           <el-table-column label="操作" width="140" align="center">

               &lt;!&ndash; <template slot="header">
                   <el-button type="primary" size="small" @click="addTable">添加</el-button>
               </template> &ndash;&gt;
               <template slot-scope="scope">
                   <el-button type="danger" size="small" @click="del(scope)">
                       删除
                   </el-button>
               </template>
           </el-table-column>
       </el-table> -->
        <span slot="footer" class="dialog-footer">
            <el-row type="flex" justify="space-between" align="middle">
<!--                <div>共 {{ tableData.length }} 条</div>-->
              <div></div>
                <el-button type="primary" @click="WarehousingDetermine" :loading="loadingStatus">确 定</el-button>
            </el-row>
            <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
        </span>
    </el-dialog>
</template>
<script>
// import UploadExcelComponent from '@/components/UploadExcel/index.vue'

export default {
    name: "Warehousing",
    components: {
        // UploadExcelComponent
    },
    data() {
        return {
            ws: null,
            dialogVisible: false,
            tableData: [],
            formData: {
                internalConveyNumber: '',
                purchaseWeight: '',
                length: '1',
                width: '1',
                height: '1',
            },
            loadingStatus: false
        };
    },
  methods: {
        isRepeat(item) {
          const { internalConveyNumber } = item
          const resultArr = this.tableData.filter(key => key.internalConveyNumber === internalConveyNumber)
          return resultArr.length > 1 ? true : false
        },
        openWebSocket() {
          if (window.WebSocket) {
            this.ws = new WebSocket('ws://localhost:4397/');

            this.ws.onopen = (e) => {
              console.log("连接服务器成功");
              this.ws.send("start");
            }
            this.ws.onclose = (e) => {
              console.log("服务器关闭");
            }
            this.ws.onerror = (e) => {
              console.log("连接出错", e);
            }
            this.ws.onmessage = (e) => {
            //   console.log(e);
              const dataStr = e.data
              this.formData.purchaseWeight = dataStr
            }
          }
        },
        hanldeKeyup(e) {
            // if (!this.formData.purchaseWeight || !this.formData.internalConveyNumber || !this.dialogVisible) return
            if (e.keyCode === 13) {
                // this.addTable()
              this.WarehousingDetermine()
            }
        },
        init() {
            this.dialogVisible = true;
            // this.tableData = [{ 
            //     id: 1,
            //     internalConveyNumber: "",
            //     length: '1',
            //     width: '1',
            //     height: '1',
            //     purchaseWeight: "" 
            // }];
            this.tableData = [];
            this.openWebSocket()
            window.addEventListener('keyup', this.hanldeKeyup)
            // this.addTable();
        },
        close() {
            this.dialogVisible = false;
            this.loadingStatus = false
            // this.$once('hook:beforeDestroy', () => {
          window.removeEventListener('keyup', this.hanldeKeyup)
            // })
        },
        closeLoading() {
          this.loadingStatus = false
          this.formData = {
            internalConveyNumber: '',
            purchaseWeight: '',
            length: '1',
            width: '1',
            height: '1',
          }
        },
        addTable() {
            this.tableData.push({
                length: '1',
                width: '1',
                height: '1',
                ...this.formData
            });
            this.formData = {
                internalConveyNumber: '',
                purchaseWeight: ''
            }
        },
        del(scope) {
            this.$confirm("您确定要删除此信息吗？", "提示")
                .then(() => {
                    const itemIndex = scope.$index
                    this.tableData.splice(itemIndex, 1)
                })
                .catch(() => {
                    this.$message.info("取消操作");
                });
        },
        WarehousingDetermine() {
            // const data = [];
            // for (const item of this.tableData) {
            //     if (item.internalConveyNumber && item.length && item.width && item.height && item.purchaseWeight) {
            //         data.push(item);
            //     } else {
            //         this.$message.warning("请将信息填写完整");
            //         return;
            //     }
            // }
            // if (!data.length) {
            //     this.$message.error("请至少填写一项信息");
            //     return;
            // }
            if (!this.formData.purchaseWeight) {
              this.$message.warning('请输入重量')
              return
            }
            if (!this.formData.internalConveyNumber) {
              this.$message.warning('请输入国内运单号')
              return
            }
            this.loadingStatus = true
            this.$emit("confirm", [this.formData]);
        },
        handleSuccess({ results, header }) {
            this.tableData = results.map((item, index) => {
                return {
                    id: index,
                    internalConveyNumber: item.国内运单号,
                    length: Number(item.长).toFixed(2),
                    width: Number(item.宽).toFixed(2),
                    height: Number(item.高).toFixed(2),
                    purchaseWeight: Number(item.重量).toFixed(2)
                }
            })
            // this.tableHeader = header
            console.log(results, header)
        }
    }
};
</script>
